export enum ApplicationCode {
  NONE = 0,
  DERM = 1,
  OSAS = 2,
  DIAB = 3,
}
